import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";

const OnboardingSettingsModal = ({
  onClose,
  settingsData,
  editOnboardSettingsMutate,
  isonboardSettingsLoading,
}) => {
  const [settings, setSettings] = useState({
    aadhaarOtpVerification: settingsData?.aadhaarOtpVerification === 1,
    policeVerification: settingsData?.policeVerification === 1,
    onlinePayment: settingsData?.onlinePayment === 1,
    rentAgreement: settingsData?.rentAgreement === 1,
    rentalBond: settingsData?.rentalBond === 1,
  });

  const toggleSetting = (key, isEnabled) => {
    const updatedState = { ...settings, [key]: !settings[key] };
    setSettings(updatedState);
    editOnboardSettingsMutate({ key, isEnabled });
  };

  return (
    <Container>
      <Header>
        <Title className="text-white">Onboarding Settings</Title>
        <button onClick={onClose}>
          <MdClose color="white" size={24} />
        </button>
      </Header>

      <ScrollableContent>
        <Wrapper>
          <Section>
            <SectionTitle>Settings</SectionTitle>
            <ToggleRow>
              <div>
                <Label>Aadhaar OTP Verification</Label>
                <Description>
                  Verify tenant identity securely and streamline <br/>the onboarding process.
                </Description>
              </div>
              <Toggle
                checked={settings.aadhaarOtpVerification}
                onChange={() => toggleSetting("aadhaarOtpVerification", !settings.aadhaarOtpVerification)}
              />
            </ToggleRow>
            <ToggleRow>
              <div>
                <Label>Police Verification</Label>
                <Description>
                  Enable this to conduct a thorough police <br/> verification process.
                </Description>
              </div>
              <Toggle
                checked={settings.policeVerification}
                onChange={() => toggleSetting("policeVerification", !settings.policeVerification)}
              />
            </ToggleRow>
            <ToggleRow>
              <div>
                <Label>Online Payment</Label>
                <Description>
                  Allow tenants to make secure and hassle-free <br/> online payments.
                </Description>
              </div>
              <Toggle
                checked={settings.onlinePayment}
                onChange={() => toggleSetting("onlinePayment", !settings.onlinePayment)}
              />
            </ToggleRow>
            <ToggleRow>
              <div>
                <Label>Generate Rent Agreement</Label>
                <Description>
                  Simplify the rental process with a digital rent <br/> agreement.
                </Description>
                <EditButton title="view aggrement" onClick={()=>{console.log("edit basic detail")}}
              >
                View Rent Agreement</EditButton>
              </div>
              <Toggle
                checked={settings.rentAgreement}
                onChange={() => toggleSetting("rentAgreement", !settings.rentAgreement)}
              />
            </ToggleRow>
            <Row>
              <div>
                <Label>Enable Rental Bond</Label>
                <Description>
                  Enhance security with Rental Bond for a hassle-free<br/> leasing experience.
                </Description>
              </div>
              <Toggle
                checked={settings.rentalBond}
                onChange={() => toggleSetting("rentalBond", !settings.rentalBond)}
              />
            </Row>
          </Section>
        </Wrapper>
      </ScrollableContent>
    </Container>
  );
};
const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const ScrollableContent = tw.div`px-4 h-full flex flex-col justify-between pb-4 relative`;
const Wrapper = tw.div`grid gap-6 my-6`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const Section = tw.div``;
const SectionTitle = tw.h2`text-lg font-semibold text-gray-600`;
const ToggleRow = tw.div`flex justify-between py-2 border-b border-gray-200 items-center`;
const Row = tw.div`flex justify-between py-2 items-center`;
const Label = tw.span`text-gray-600`;
const Description = tw.p`text-gray-400 text-sm md:mx-1`;
const EditButton = tw.button` text-sm px-1 py-0.5 items-center flex justify-between text-primary-color`

const Toggle = ({ checked, onChange }) => (
  <label className="relative inline-flex items-center cursor-pointer">
    <input
      type="checkbox"
      className="sr-only peer"
      checked={checked}
      onChange={onChange}
    />
    <div className="w-11 h-6 bg-gray-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
  </label>
);

export default OnboardingSettingsModal;